import { MuiF } from '../../../../../../Mui/F/Function/module/MuiF.js';
import { VectorEditorStickerSinglePCCuttingLineAutoF } from '../../CuttingLineAuto/F/Function/module/VectorEditorStickerSinglePCCuttingLineAutoF.js';
import { $closest, $find, $scrollTop, $setScrollTop } from 'fxdom/es';

export const handleRightCancelButtonClick = () => MuiF.closeFrame(null);

export const handleRightDoneButtonClick =
  ({ tab_el }) =>
  async () => {
    const editor = tab_el.__mp_single_sticker_editor;
    if (editor == null) {
      return;
    }

    try {
      await tab_el?.__mp_postProcess?.(editor);
    } catch (error) {
      console.error(error);
      $.alert(error.__mp_alert_message ?? T('modules::VectorEditor::Sticker::message::fail_image'));
      return;
    }

    MuiF.closeFrame();
  };

export const handleRightNextButtonClick =
  ({ tab_el }) =>
  async () => {
    try {
      if (tab_el.__mp_single_sticker_editor.getGraphicsEls().size <= 0) {
        /** @todo alert message */
        return;
      }

      if ($scrollTop(window) > 30) {
        await window.anime({
          targets: 'html, body',
          scrollTop: 0,
          duration: 400,
          easing: 'easeInOutCubic',
        }).finished;
      } else {
        $setScrollTop(0)(window);
      }

      const page_el = $closest('.don_page')(tab_el);
      tab_el.__mp_is_go_to_next_page = true;
      page_el.style.display = 'block';
      await VectorEditorStickerSinglePCCuttingLineAutoF.makeCuttingLineAuto({
        single_sticker_editor: tab_el.__mp_single_sticker_editor,
        frame_position: { top: tab_el.__mp_frame_position_top, height: tab_el.__mp_frame_position_height },
        postProcess: tab_el.__mp_postProcess,
        prev_frame_right_panel_el: tab_el.__mp_prev_right_panel,
        prev_page_right_panel_el: $find(`.right_container .right_wrapper`)(tab_el),
        editor_padding: {
          top: tab_el.__mp_editor_padding_top,
          right: tab_el.__mp_editor_padding_right,
          bottom: tab_el.__mp_editor_padding_bottom,
          left: tab_el.__mp_editor_padding_left,
        },
      });
      page_el.style.removeProperty('display');
    } catch (error) {
      await $.alert(T('modules::VectorEditor::Sticker::message::cutting_line_making_error'));
      throw error;
    }
  };
